module.exports = __webpack_public_path__ + "static/dimm3-424947dcb20cccd1a4e77aab8b73576c.mp4";